import { render, staticRenderFns } from "./Wo.vue?vue&type=template&id=18b1d96f&scoped=true&"
import script from "./Wo.vue?vue&type=script&lang=js&"
export * from "./Wo.vue?vue&type=script&lang=js&"
import style0 from "./Wo.vue?vue&type=style&index=0&id=18b1d96f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1d96f",
  null
  
)

export default component.exports